import { render, staticRenderFns } from "./vuex-radio-group.vue?vue&type=template&id=554855b8&scoped=true"
import script from "./vuex-radio-group.vue?vue&type=script&lang=js"
export * from "./vuex-radio-group.vue?vue&type=script&lang=js"
import style0 from "./vuex-radio-group.vue?vue&type=style&index=0&id=554855b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554855b8",
  null
  
)

export default component.exports